import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';

const COOKIE_KEY = 'sera_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);
    if (!saved) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ analytics: true, ts: Date.now() }));
    setVisible(false);
  }

  function reject() {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ analytics: false, ts: Date.now() }));
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99999,
        width: 'calc(100% - 32px)',
        maxWidth: 680,
        background: '#18181b',
        border: '1px solid #3f3f46',
        borderRadius: 14,
        boxShadow: '0 8px 40px rgba(0,0,0,0.55)',
        padding: '18px 20px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 14,
        animation: 'sera-cookie-in 0.3s ease-out',
      }}
    >
      <style>{`
        @keyframes sera-cookie-in {
          from { opacity: 0; transform: translateX(-50%) translateY(16px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>

      {/* Icon */}
      <span style={{ color: '#a78bfa', marginTop: 2, flexShrink: 0 }}>
        <Cookie size={20} />
      </span>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: '0 0 4px', fontSize: 14, fontWeight: 600, color: '#f4f4f5' }}>
          Usamos cookies
        </p>
        <p style={{ margin: 0, fontSize: 13, color: '#a1a1aa', lineHeight: 1.6 }}>
          Utilizamos cookies propias necesarias para el funcionamiento del servicio y, con tu
          consentimiento, cookies analíticas (Google Analytics) para mejorar la experiencia.
          Puedes consultar nuestra{' '}
          <Link to="/cookies" style={{ color: '#a78bfa', textDecoration: 'underline' }}>
            Política de Cookies
          </Link>
          .
        </p>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0, flexWrap: 'wrap' }}>
        <button
          data-testid="cookie-reject-btn"
          onClick={reject}
          style={{
            padding: '7px 14px',
            fontSize: 13,
            fontWeight: 500,
            borderRadius: 8,
            border: '1px solid #3f3f46',
            background: 'transparent',
            color: '#a1a1aa',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Solo necesarias
        </button>
        <button
          data-testid="cookie-accept-btn"
          onClick={accept}
          style={{
            padding: '7px 16px',
            fontSize: 13,
            fontWeight: 600,
            borderRadius: 8,
            border: 'none',
            background: '#6366f1',
            color: '#fff',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Aceptar todo
        </button>
        <button
          data-testid="cookie-close-btn"
          onClick={reject}
          aria-label="Cerrar"
          style={{
            background: 'none',
            border: 'none',
            color: '#52525b',
            cursor: 'pointer',
            padding: 4,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
